import { memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import MonthlyBillComponent from './MonthlyBillComponent';

import { getMonthlyBill } from './actions';

import { arePropsEqual } from '../../utils';
import { getMonthlyBillItems } from './utils';

const MonthlyBillContainer = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.monthlyBill);
  const items = getMonthlyBillItems(data);

  const onLoad = () => getMonthlyBill(dispatch);

  const onExport = () => ({
    data: { results: items },
  });

  return (
    <MonthlyBillComponent items={items} onExport={onExport} onLoad={onLoad} />
  );
};

export default memo(MonthlyBillContainer, arePropsEqual);
